module.exports = __webpack_public_path__ + "static/media/2.337b5224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 379
// module chunks = 0